import React from "react";
import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";

const DateTimePicker = (props) => <DatePicker {...props} />

export default DateTimePicker;